import {twJoin} from 'tailwind-merge'

import {KeyFact} from '@sdox/ui'
import {AspectRatioEnum, BlockKeyFactVisualizationEnum} from '@sdox/api'

import {GenericButton} from '../../Buttons/GenericButton'

import type {XcNwBlock_KeyFactTypeBlockRowType_Fragment} from '@sdox/api'
import type {AspectRatio} from '@sdox/ui'

export type BlockKeyFactRowProps = XcNwBlock_KeyFactTypeBlockRowType_Fragment

const aspectRatioMap: Record<AspectRatioEnum, AspectRatio> = {
  [AspectRatioEnum.Aspect_1_1]: '1/1',
  [AspectRatioEnum.Aspect_2_3]: '2/3',
  [AspectRatioEnum.Aspect_3_2]: '3/2',
  [AspectRatioEnum.Aspect_3_4]: '3/4',
  [AspectRatioEnum.Aspect_4_3]: '4/3',
  [AspectRatioEnum.Aspect_16_9]: '16/9',
  [AspectRatioEnum.Aspect_16_10]: '16/10',
}

export const BlockKeyFactRow = (props: BlockKeyFactRowProps) => {
  const {
    items,
    aspectRatio,
    keyFactVisualization,
  } = props

  const itemCount = items.length
  const withImage = keyFactVisualization === BlockKeyFactVisualizationEnum.WithImage

  return (
    <div className={'@container/block'}>
      <div
        className={twJoin(
          'grid grid-cols-1 gap-spacing-48 @block-medium:gap-block-medium',
          itemCount > 1 && '@block-medium:grid-cols-2',
        )}
      >
        {items.map((keyFact, idx) => (
          <KeyFact
            key={idx}
            aspectRatio={aspectRatio ? aspectRatioMap[aspectRatio] : '3/2'}
            heading={keyFact.title ?? ''}
            callout={keyFact.callOut ?? undefined}
            description={keyFact.description ?? undefined}
            cta={keyFact.cta
              ? <GenericButton {...keyFact.cta}/>
              : undefined}
            media={withImage ? {
              imageProps: {
                src: keyFact.image?.thumbnailUrl,
                placeholderSrc: keyFact.image?.thumbnailUrl380w,
                alt: keyFact.image?.altText ?? keyFact.title ?? '',
                width: keyFact.image?.originalThumbnailDimensions?.width,
                height: keyFact.image?.originalThumbnailDimensions?.height,
              },
              hasDivider: keyFact.mediaDivider,
            } : undefined}
          />
        ))}
      </div>
    </div>
  )
}
